// setSelectionRange alone does not scroll a controlled input in Safari/Chrome.
export function revealDictationCaret(target, caret) {
  if (target.isContentEditable) {
    const range = window.getSelection()?.rangeCount ? window.getSelection().getRangeAt(0) : null;
    const rect = range?.getBoundingClientRect?.(), box = target.getBoundingClientRect();
    if (rect?.height) {
      if (rect.bottom > box.bottom) target.scrollTop += rect.bottom - box.bottom + 8;
      if (rect.top < box.top) target.scrollTop -= box.top - rect.top + 8;
    }
    return;
  }
  target.setSelectionRange?.(caret, caret);
  const style = window.getComputedStyle(target);
  if (target.tagName === 'TEXTAREA') {
    const mirror = document.createElement('div'), marker = document.createElement('span');
    for (const key of ['font', 'letterSpacing', 'lineHeight', 'padding', 'border', 'boxSizing', 'wordSpacing', 'tabSize']) mirror.style[key] = style[key];
    Object.assign(mirror.style, { position: 'fixed', visibility: 'hidden', width: `${target.offsetWidth}px`, whiteSpace: 'pre-wrap', overflowWrap: 'break-word' });
    mirror.textContent = target.value.slice(0, caret); marker.textContent = target.value.slice(caret) || '.'; mirror.append(marker); document.body.append(mirror);
    const top = marker.offsetTop, height = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.4;
    if (top + height > target.scrollTop + target.clientHeight) target.scrollTop = top + height - target.clientHeight + 8;
    if (top < target.scrollTop) target.scrollTop = top;
    mirror.remove();
  } else {
    const canvas = document.createElement('canvas'), context = canvas.getContext('2d');
    if (!context) return;
    context.font = style.font;
    const x = context.measureText(target.value.slice(0, caret)).width + (parseFloat(style.letterSpacing) || 0) * caret;
    const width = target.clientWidth - (parseFloat(style.paddingLeft) || 0) - (parseFloat(style.paddingRight) || 0);
    if (x > target.scrollLeft + width - 8) target.scrollLeft = Math.max(0, x - width + 8);
    if (x < target.scrollLeft + 8) target.scrollLeft = Math.max(0, x - 8);
  }
}
